import apiClient from "../../utils/request";

/**
 * 修改昵称
 */
export const updateNickname = async ({ nickname }) =>
  await apiClient.patch("/api/user", { nickname });

/**
 * 修改/解绑手机号或邮箱
  */
export const updatePhone = async ({ field, value,code }) =>
  await apiClient.patch("/api/user/updatePhoneOrEmail", { field, value,code });